/* Second Bloom — records saves, unsaves and cart adds, and runs the WhatsApp alerts opt-in.
   Works in any copy of the theme without setup. To stop a theme recording, put 'off' in the
   data endpoint (Header → Mobile tab bar & menu). */
(function () {
  if (window.__sbTrack) return;
  window.__sbTrack = true;

  var cfg = window.SBData || {};
  // Built in on purpose, so duplicating, renaming or publishing a theme keeps recording even
  // if the theme setting is empty. The setting in the theme editor overrides this when filled;
  // put 'off' in it to stop a theme sending anything.
  var HOME = 'https://hbpivsyberztyihnbpdy.supabase.co/functions/v1/sb';
  var BASE = (cfg.endpoint || HOME).replace(/\/+$/, '');
  if (/^off$/i.test(BASE)) BASE = '';
  var SID_KEY = 'sb_sid_v1';
  var OPTIN_KEY = 'sb_optin_v1';
  var QUEUE_KEY = 'sb_queue_v1';
  var SEEN_KEY = 'sb_seen_v1';

  function store(key, fallback) {
    try {
      var v = window.localStorage.getItem(key);
      return v ? JSON.parse(v) : fallback;
    } catch (e) { return fallback; }
  }
  function put(key, value) {
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  // A random id for this browser, so saves made today can be joined to an order placed later.
  function sid() {
    var v = store(SID_KEY, null);
    if (typeof v === 'string' && v.length > 8) return v;
    var bytes = new Uint8Array(16);
    (window.crypto || window.msCrypto).getRandomValues(bytes);
    var out = '';
    for (var i = 0; i < bytes.length; i++) out += ('0' + bytes[i].toString(16)).slice(-2);
    put(SID_KEY, out);
    return out;
  }
  var SID = sid();
  window.SBData = Object.assign({}, cfg, { sid: SID });

  /* ---------- sending ---------- */

  function post(path, body, beacon) {
    if (!BASE) return Promise.resolve(false);
    var url = BASE + path;
    var payload = JSON.stringify(Object.assign(
      { v: 1, sid: SID, shop: cfg.shop || location.host, theme: cfg.theme || null },
      body
    ));
    if (beacon && navigator.sendBeacon) {
      try {
        if (navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }))) return Promise.resolve(true);
      } catch (e) {}
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }

  // Events wait in the browser until they are accepted, so a dropped connection loses nothing.
  var queue = store(QUEUE_KEY, []);
  if (!Array.isArray(queue)) queue = [];
  var flushing = false;

  function flush(beacon) {
    if (!BASE || flushing || !queue.length) return;
    flushing = true;
    var batch = queue.slice(0, 40);
    post('/events', { events: batch }, beacon).then(function (ok) {
      flushing = false;
      if (!ok) return;
      queue = queue.slice(batch.length);
      put(QUEUE_KEY, queue);
      if (queue.length) flush();
    });
  }

  // Several parts of the theme can announce the same save in the same instant. This short
  // memory lives in localStorage rather than in a variable, so it still holds if this script
  // ends up on the page more than once.
  function first(key, ms) {
    var seen = store(SEEN_KEY, {});
    if (!seen || typeof seen !== 'object') seen = {};
    var now = Date.now();
    Object.keys(seen).forEach(function (k) { if (now - seen[k] > 180000) delete seen[k]; });
    var twice = seen[key] && now - seen[key] < ms;
    if (!twice) seen[key] = now;
    put(SEEN_KEY, seen);
    return !twice;
  }

  function forget(key) {
    var seen = store(SEEN_KEY, {});
    if (seen && typeof seen === 'object' && seen[key]) {
      delete seen[key];
      put(SEEN_KEY, seen);
    }
  }

  function track(type, item, extra) {
    var handle = item ? (item.h || item.handle) : null;
    var enrich = !!(extra && extra.enrich);
    // An enrichment carries the price and product id that arrive a moment after the tap;
    // it updates the saved piece without being counted as a second save.
    if (enrich) {
      if (!handle || !first('enrich:' + handle, 180000)) return;
    } else {
      if (!first(type + ':' + (handle || ''), 4000)) return;
      // Saving and unsaving are opposites, so each one clears the memory of the other:
      // a shopper who taps the heart twice in a row is still recorded properly.
      if (type === 'save') {
        forget('unsave:' + handle);
      } else if (type === 'unsave') {
        forget('save:' + handle);
        forget('enrich:' + handle);
      }
    }
    var e = Object.assign({
      type: type,
      at: new Date().toISOString(),
      path: location.pathname,
      device: window.matchMedia('(max-width: 749px)').matches ? 'phone' : 'desktop'
    }, extra || {});
    if (item) {
      e.handle = handle;
      if (item.id) e.product_id = item.id;
      // Shopify reports prices in piastres; the dashboard wants pounds.
      if (typeof item.price === 'number') e.price = item.price / 100;
      if (item.title) e.title = item.title;
    }
    queue.push(e);
    if (queue.length > 300) queue = queue.slice(-300);
    put(QUEUE_KEY, queue);
    flush();
  }
  window.SBTrack = track;

  document.addEventListener('visibilitychange', function () { if (document.hidden) flush(true); });
  window.addEventListener('pagehide', function () { flush(true); });
  flush();

  /* ---------- saves and unsaves ---------- */

  function handles() {
    return (window.SBFav ? window.SBFav.list() : []).map(function (x) { return x.h; });
  }
  var known = handles();

  // Anything a shopper saved before this was switched on — on the old theme, or while the
  // endpoint was still blank — would otherwise never be counted, because only changes are
  // noticed from here on. So the first time there is somewhere to send them, send the whole
  // list once. Saving the same piece twice is harmless: the database keeps one row per piece.
  var SYNC_KEY = 'sb_synced_v1';
  function backfill() {
    if (!BASE || store(SYNC_KEY, false)) return;
    var list = window.SBFav ? window.SBFav.list() : [];
    put(SYNC_KEY, true);
    var queued = {};
    queue.forEach(function (q) { if (q.type === 'save' && q.handle) queued[q.handle] = 1; });
    list.forEach(function (item) {
      if (!item || !item.h || queued[item.h]) return;
      var when = item.t ? { at: new Date(item.t).toISOString() } : null;
      track('save', item, when);
      // These already carry their price, so there is nothing left to fill in later.
      if (typeof item.price === 'number') first('enrich:' + item.h, 180000);
    });
  }
  if (window.SBFav) backfill();
  else document.addEventListener('DOMContentLoaded', backfill);

  document.addEventListener('sb:favourites-changed', function () {
    var list = window.SBFav ? window.SBFav.list() : [];
    var now = list.map(function (x) { return x.h; });
    now.forEach(function (h) {
      var item = list.filter(function (x) { return x.h === h; })[0];
      if (known.indexOf(h) === -1) {
        track('save', item);
      }
      if (item && typeof item.price === 'number') {
        track('save', item, { enrich: true });
      }
    });
    known.forEach(function (h) {
      if (now.indexOf(h) === -1) track('unsave', { h: h });
    });
    known = now;
    tagCart();
    optin.refresh();
  });

  /* ---------- cart adds ---------- */

  var lastCart = null;
  var cartBusy = false;

  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function snapshot(cart) {
    var m = {};
    (cart && cart.items ? cart.items : []).forEach(function (i) { m[i.key] = i.quantity; });
    return m;
  }

  function checkCart() {
    if (cartBusy) return;
    cartBusy = true;
    readCart().then(function (cart) {
      cartBusy = false;
      if (!cart) return;
      var now = snapshot(cart);
      if (lastCart) {
        cart.items.forEach(function (i) {
          var before = lastCart[i.key] || 0;
          if (i.quantity > before) {
            track('add_to_cart', { h: i.handle, id: i.product_id, price: i.price, title: i.product_title }, { variant_id: i.variant_id });
          }
        });
      }
      lastCart = now;
      tagCart(cart);
    });
  }

  // Write the browser id onto the cart, so Shopify keeps it on the order and the saves can be
  // matched to a name and phone number later.
  var tagging = false;
  function tagCart(cart) {
    if (tagging) return;
    var go = function (c) {
      if (!c || !c.items || !c.items.length) return;
      if (c.attributes && c.attributes.sb_sid === SID) return;
      tagging = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { sb_sid: SID } })
      }).then(function () { tagging = false; }).catch(function () { tagging = false; });
    };
    if (cart) go(cart); else readCart().then(go);
  }

  ['sb:cart-changed', 'cart:item-added', 'cart:refresh', 'line-item:change:end', 'cart:updated'].forEach(function (n) {
    document.addEventListener(n, function () { setTimeout(checkCart, 300); });
  });

  function warmCart() { readCart().then(function (c) { lastCart = snapshot(c); tagCart(c); }); }
  if (window.requestIdleCallback) window.requestIdleCallback(warmCart, { timeout: 3000 });
  else setTimeout(warmCart, 1200);

  /* ---------- the alerts opt-in ---------- */

  var optin = {
    saved: function () { return store(OPTIN_KEY, null); },
    refresh: function () {}
  };
  window.SBOptIn = optin;

  function digits(s) { return String(s || '').replace(/[^0-9]/g, ''); }

  // Egyptian mobile numbers: 11 digits starting 010, 011, 012 or 015.
  function normalise(raw) {
    var d = digits(raw);
    if (d.indexOf('0020') === 0) d = d.slice(4);
    else if (d.indexOf('20') === 0 && d.length > 11) d = d.slice(2);
    if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
    if (d.length !== 10 || d.charAt(0) !== '1') return null;
    if (['0', '1', '2', '5'].indexOf(d.charAt(1)) === -1) return null;
    return '+20' + d;
  }
  function pretty(p) {
    var d = digits(p).slice(-10);
    return '+20 ' + d.slice(0, 2) + '•• ••• ' + d.slice(-4);
  }

  function setUp() {
    var bar = document.querySelector('[data-sb-optin-open]');
    var done = document.querySelector('[data-sb-optin-done]');
    var sheet = document.querySelector('[data-sb-optin-sheet]');
    if (!bar || !sheet) return;

    var form = sheet.querySelector('form');
    var input = sheet.querySelector('[data-sb-optin-phone]');
    var alerts = sheet.querySelector('[data-sb-consent-alerts]');
    var drops = sheet.querySelector('[data-sb-consent-drops]');
    var error = sheet.querySelector('[data-sb-optin-error]');
    var shown = done ? done.querySelector('[data-sb-optin-number]') : null;

    function render() {
      var on = optin.saved();
      var any = window.SBFav ? window.SBFav.count() > 0 : false;
      bar.hidden = !!on || !any;
      if (done) done.hidden = !on || !any;
      if (on && shown) shown.textContent = pretty(on.phone);
    }
    optin.refresh = render;

    function open() {
      sheet.hidden = false;
      requestAnimationFrame(function () { sheet.classList.add('is-open'); });
      document.documentElement.classList.add('sbn-lock');
      var on = optin.saved();
      if (on) {
        input.value = digits(on.phone).slice(-10);
        alerts.checked = on.alerts !== false;
        drops.checked = !!on.drops;
      }
      setTimeout(function () { input.focus(); }, 180);
    }
    function close() {
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('sbn-lock');
      setTimeout(function () { sheet.hidden = true; }, 260);
    }

    bar.addEventListener('click', open);
    if (done) {
      var change = done.querySelector('[data-sb-optin-change]');
      if (change) change.addEventListener('click', open);
    }
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet || e.target.closest('[data-sb-optin-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) close();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var phone = normalise(input.value);
      if (!phone) {
        error.hidden = false;
        input.focus();
        return;
      }
      error.hidden = true;
      var record = {
        phone: phone,
        alerts: !!alerts.checked,
        drops: !!drops.checked,
        at: new Date().toISOString(),
        wording: (sheet.getAttribute('data-sb-wording') || '').trim()
      };
      put(OPTIN_KEY, record);
      post('/optin', record);
      track('optin', null, { alerts: record.alerts, drops: record.drops });
      close();
      render();
    });

    document.addEventListener('sb:favourites-changed', render);
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setUp);
  else setUp();
})();